import { render } from "./DealersPageContent.vue?vue&type=template&id=2425abec"
import script from "./DealersPageContent.vue?vue&type=script&lang=js"
export * from "./DealersPageContent.vue?vue&type=script&lang=js"

import "./DealersPageContent.vue?vue&type=style&index=0&id=2425abec&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__